'use strict';

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _require = require('./symbols'),
    func = _require.func;

var objectPredicates = _defineProperty({
  plain: function plain(value) {
    if (typeof value !== 'object') return false;
    var proto = Object.getPrototypeOf(value);
    return proto === null || proto === Object.getPrototypeOf({});
  },
  empty: function empty(value) {
    return Object.keys(value).length === 0;
  },
  nonEmpty: function nonEmpty(value) {
    return Object.keys(value).length > 0;
  }
}, func, {
  is: function is(fn) {
    return fn;
  },
  instanceOf: function instanceOf(v) {
    return function (value) {
      return value instanceof v;
    };
  }
});

module.exports = {
  predicates: objectPredicates,
  validator: function validator(value) {
    return typeof value === 'object';
  }
};